module.exports = __webpack_public_path__ + "assets/img/COUPLE2.87831220.png";